import TrainingSubscription from 'actions/training/subscription';

export default TrainingSubscription.createReducer();